/*
 * write.js — the track model back out to every format a person needs.
 *
 *   GpsWrite.gpx(doc, o)      GPX 1.1 (+ Garmin TrackPointExtension, <power>)
 *   GpsWrite.kml(doc, o)      KML 2.2; o.timed → gx:Track (Google Earth time slider)
 *   GpsWrite.geojson(doc, o)  RFC 7946 + the togeojson coordinateProperties convention
 *   GpsWrite.tcx(doc, o)      Training Center; o.course → a Course for navigation
 *   GpsWrite.csv(doc, o)
 *   GpsWrite.fit(doc, o)      FIT activity, or o.course → a FIT course a watch loads
 *
 * Every writer returns a string except fit(), which returns a Uint8Array.
 * A writer writes what the model holds: stripping time or heart rate for
 * privacy is an edit on the model (edit.js), not an option here, so what the
 * person previewed is exactly what they download.
 */
(function () {
    'use strict';
    var root = typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : this);

    function esc(s) {
        return String(s == null ? '' : s).replace(/[<>&"']/g, function (c) {
            return c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '&' ? '&amp;' : c === '"' ? '&quot;' : '&apos;';
        }).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '');
    }
    function iso(ms) {
        if (ms == null || isNaN(ms)) return null;
        var s = new Date(ms).toISOString();
        return ms % 1000 ? s : s.replace('.000Z', 'Z');
    }
    function f7(v) { return (Math.round(v * 1e7) / 1e7).toString(); }
    function f1(v) { return (Math.round(v * 10) / 10).toString(); }
    function ok(v) { return v != null && !isNaN(v); }
    function prolog() { return '<' + '?xml version="1.0" encoding="UTF-8"?' + '>\n'; }

    // ── GPX ────────────────────────────────────────────────────────────────
    function gpx(doc, o) {
        o = o || {};
        var creator = o.creator || 'Timbrica';
        var out = [prolog(),
            '<gpx version="1.1" creator="' + esc(creator) + '" xmlns="http://www.topografix.com/GPX/1/1"',
            ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"',
            ' xmlns:gpxtpx="http://www.garmin.com/xmlschemas/TrackPointExtension/v1"',
            ' xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd http://www.garmin.com/xmlschemas/TrackPointExtension/v1 http://www8.garmin.com/xmlschemas/TrackPointExtensionv1.xsd">\n'];
        var meta = [];
        if (doc.name) meta.push('<name>' + esc(doc.name) + '</name>');
        var t0 = firstTime(doc);
        if (t0 != null) meta.push('<time>' + iso(t0) + '</time>');
        if (meta.length) out.push(' <metadata>' + meta.join('') + '</metadata>\n');
        (doc.waypoints || []).forEach(function (w) { out.push(' ' + gpxPt('wpt', w.lat, w.lon, w.ele, w.time, null, w) + '\n'); });
        (doc.tracks || []).forEach(function (t) {
            var asRoute = o.routes || t.kind === 'route' && o.routes !== false;
            if (asRoute) {
                // a route is ONE list of points; several segments become several routes
                t.segs.forEach(function (s, si) {
                    out.push(' <rte>' + (t.name ? '<name>' + esc(t.name + (t.segs.length > 1 ? ' ' + (si + 1) : '')) + '</name>' : '') + '\n');
                    for (var i = 0; i < s.n; i++) out.push('  ' + gpxPt('rtept', s.lat[i], s.lon[i], s.ele ? s.ele[i] : null, s.time ? s.time[i] : null, null, null) + '\n');
                    out.push(' </rte>\n');
                });
                return;
            }
            out.push(' <trk>');
            if (t.name) out.push('<name>' + esc(t.name) + '</name>');
            if (t.desc) out.push('<desc>' + esc(t.desc) + '</desc>');
            if (t.sport) out.push('<type>' + esc(t.sport) + '</type>');
            out.push('\n');
            t.segs.forEach(function (s) {
                out.push('  <trkseg>\n');
                for (var i = 0; i < s.n; i++) {
                    out.push('   ' + gpxPt('trkpt', s.lat[i], s.lon[i], s.ele ? s.ele[i] : null, s.time ? s.time[i] : null, s.ch, null, i) + '\n');
                }
                out.push('  </trkseg>\n');
            });
            out.push(' </trk>\n');
        });
        out.push('</gpx>\n');
        return out.join('');
    }
    function gpxPt(tag, lat, lon, ele, time, ch, w, i) {
        var s = '<' + tag + ' lat="' + f7(lat) + '" lon="' + f7(lon) + '">';
        if (ok(ele)) s += '<ele>' + f1(ele) + '</ele>';
        if (ok(time)) s += '<time>' + iso(time) + '</time>';
        if (w) {
            if (w.name) s += '<name>' + esc(w.name) + '</name>';
            if (w.desc) s += '<desc>' + esc(w.desc) + '</desc>';
            if (w.sym) s += '<sym>' + esc(w.sym) + '</sym>';
            if (w.type) s += '<type>' + esc(w.type) + '</type>';
        }
        if (ch) {
            var tpx = '';
            // schema order: atemp, wtemp, depth, hr, cad
            if (ch.temp && ok(ch.temp[i])) tpx += '<gpxtpx:atemp>' + f1(ch.temp[i]) + '</gpxtpx:atemp>';
            if (ch.depth && ok(ch.depth[i])) tpx += '<gpxtpx:depth>' + f1(ch.depth[i]) + '</gpxtpx:depth>';
            if (ch.hr && ok(ch.hr[i])) tpx += '<gpxtpx:hr>' + Math.round(ch.hr[i]) + '</gpxtpx:hr>';
            if (ch.cad && ok(ch.cad[i])) tpx += '<gpxtpx:cad>' + Math.round(ch.cad[i]) + '</gpxtpx:cad>';
            var pw = ch.power && ok(ch.power[i]) ? '<power>' + Math.round(ch.power[i]) + '</power>' : '';
            if (tpx || pw) s += '<extensions>' + pw + (tpx ? '<gpxtpx:TrackPointExtension>' + tpx + '</gpxtpx:TrackPointExtension>' : '') + '</extensions>';
        }
        return s + '</' + tag + '>';
    }

    function firstTime(doc) {
        for (var k = 0; k < (doc.tracks || []).length; k++) {
            var t = doc.tracks[k];
            for (var s = 0; s < t.segs.length; s++) {
                var tt = t.segs[s].time;
                if (tt) for (var i = 0; i < tt.length; i++) if (ok(tt[i])) return tt[i];
            }
        }
        return doc.time != null ? doc.time : null;
    }

    // ── KML ────────────────────────────────────────────────────────────────
    function kmlColor(hex, alpha) {
        var h = (hex || '#e5484d').replace('#', '');
        if (h.length !== 6) h = 'e5484d';
        return (alpha || 'ff') + h.slice(4, 6) + h.slice(2, 4) + h.slice(0, 2);
    }
    function kml(doc, o) {
        o = o || {};
        var out = [prolog(), '<kml xmlns="http://www.opengis.net/kml/2.2" xmlns:gx="http://www.google.com/kml/ext/2.2">\n<Document>\n'];
        if (doc.name) out.push('<name>' + esc(doc.name) + '</name>\n');
        var palette = o.palette || ['#e5484d', '#3e63dd', '#30a46c', '#f76b15', '#8e4ec6', '#12a594', '#d6409f', '#ffc53d'];
        (doc.tracks || []).forEach(function (t, k) {
            var col = t.color || palette[k % palette.length];
            out.push('<Style id="trk' + k + '"><LineStyle><color>' + kmlColor(col) + '</color><width>4</width></LineStyle><PolyStyle><fill>0</fill></PolyStyle></Style>\n');
        });
        if ((doc.areas || []).length) out.push('<Style id="area"><LineStyle><color>ffdd633e</color><width>2</width></LineStyle><PolyStyle><color>40dd633e</color></PolyStyle></Style>\n');
        var alt = o.absolute ? 'absolute' : 'clampToGround';
        (doc.tracks || []).forEach(function (t, k) {
            out.push('<Placemark>');
            if (t.name) out.push('<name>' + esc(t.name) + '</name>');
            if (t.desc) out.push('<description>' + esc(t.desc) + '</description>');
            out.push('<styleUrl>#trk' + k + '</styleUrl>\n');
            var timed = o.timed && t.segs.every(function (s) { return !!s.time; });
            if (timed) {
                out.push('<gx:MultiTrack><altitudeMode>' + alt + '</altitudeMode><gx:interpolate>0</gx:interpolate>\n');
                t.segs.forEach(function (s) {
                    out.push('<gx:Track>\n');
                    var i;
                    for (i = 0; i < s.n; i++) out.push('<when>' + (iso(s.time[i]) || '') + '</when>\n');
                    for (i = 0; i < s.n; i++) out.push('<gx:coord>' + f7(s.lon[i]) + ' ' + f7(s.lat[i]) + (s.ele && ok(s.ele[i]) ? ' ' + f1(s.ele[i]) : '') + '</gx:coord>\n');
                    var arr = [['hr', 'heartrate'], ['cad', 'cadence'], ['power', 'power'], ['temp', 'temperature']].filter(function (p) { return s.ch[p[0]]; });
                    if (arr.length) {
                        out.push('<ExtendedData><SchemaData schemaUrl="#tp">\n');
                        arr.forEach(function (p) {
                            out.push('<gx:SimpleArrayData name="' + p[1] + '">');
                            for (var q = 0; q < s.n; q++) { var v = s.ch[p[0]][q]; out.push('<gx:value>' + (ok(v) ? Math.round(v) : '') + '</gx:value>'); }
                            out.push('</gx:SimpleArrayData>\n');
                        });
                        out.push('</SchemaData></ExtendedData>\n');
                    }
                    out.push('</gx:Track>\n');
                });
                out.push('</gx:MultiTrack>');
            } else {
                if (t.segs.length > 1) out.push('<MultiGeometry>\n');
                t.segs.forEach(function (s) {
                    out.push('<LineString><tessellate>1</tessellate><altitudeMode>' + alt + '</altitudeMode><coordinates>\n');
                    for (var i = 0; i < s.n; i++) out.push(f7(s.lon[i]) + ',' + f7(s.lat[i]) + (s.ele && ok(s.ele[i]) ? ',' + f1(s.ele[i]) : '') + '\n');
                    out.push('</coordinates></LineString>\n');
                });
                if (t.segs.length > 1) out.push('</MultiGeometry>');
            }
            out.push('</Placemark>\n');
        });
        if (o.timed && (doc.tracks || []).some(function (t) { return t.segs.some(function (s) { return Object.keys(s.ch).length; }); })) {
            out.splice(2, 0, '<Schema id="tp"><gx:SimpleArrayField name="heartrate" type="int"/><gx:SimpleArrayField name="cadence" type="int"/><gx:SimpleArrayField name="power" type="int"/><gx:SimpleArrayField name="temperature" type="float"/></Schema>\n');
        }
        (doc.waypoints || []).forEach(function (w) {
            out.push('<Placemark>' + (w.name ? '<name>' + esc(w.name) + '</name>' : '') + (w.desc ? '<description>' + esc(w.desc) + '</description>' : '') +
                (ok(w.time) ? '<TimeStamp><when>' + iso(w.time) + '</when></TimeStamp>' : '') +
                '<Point><coordinates>' + f7(w.lon) + ',' + f7(w.lat) + (ok(w.ele) ? ',' + f1(w.ele) : '') + '</coordinates></Point></Placemark>\n');
        });
        (doc.areas || []).forEach(function (a) {
            out.push('<Placemark>' + (a.name ? '<name>' + esc(a.name) + '</name>' : '') + '<styleUrl>#area</styleUrl><Polygon>');
            a.rings.forEach(function (r, ri) {
                out.push(ri === 0 ? '<outerBoundaryIs>' : '<innerBoundaryIs>');
                out.push('<LinearRing><coordinates>' + r.map(function (p) { return f7(p[0]) + ',' + f7(p[1]); }).join(' ') + '</coordinates></LinearRing>');
                out.push(ri === 0 ? '</outerBoundaryIs>' : '</innerBoundaryIs>');
            });
            out.push('</Polygon></Placemark>\n');
        });
        out.push('</Document>\n</kml>\n');
        return out.join('');
    }

    // ── GeoJSON ────────────────────────────────────────────────────────────
    function geojson(doc, o) {
        o = o || {};
        var feats = [];
        (doc.tracks || []).forEach(function (t) {
            var lines = t.segs.map(function (s) {
                var c = new Array(s.n);
                for (var i = 0; i < s.n; i++) {
                    var p = [+f7(s.lon[i]), +f7(s.lat[i])];
                    if (s.ele && ok(s.ele[i])) p.push(+f1(s.ele[i]));
                    c[i] = p;
                }
                return c;
            });
            var props = {};
            if (t.name) props.name = t.name;
            if (t.desc) props.desc = t.desc;
            if (t.sport) props.type = t.sport;
            if (t.color) props.stroke = t.color;
            var single = lines.length === 1;
            var cp = {};
            if (t.segs.every(function (s) { return !!s.time; })) {
                var times = t.segs.map(function (s) { return Array.prototype.map.call(s.time, iso); });
                cp.times = single ? times[0] : times;
            }
            ['hr', 'cad', 'power', 'temp'].forEach(function (k) {
                // a channel present in SOME segments (sensor paired after a pause) is
                // still written, with nulls where that segment has none
                if (!t.segs.some(function (s) { return !!s.ch[k]; })) return;
                var name = k === 'hr' ? 'heart' : k === 'cad' ? 'cadence' : k === 'temp' ? 'atemps' : 'power';
                var arr = t.segs.map(function (s) {
                    if (!s.ch[k]) return new Array(s.n).fill(null);
                    return Array.prototype.map.call(s.ch[k], function (v) { return ok(v) ? Math.round(v * 10) / 10 : null; });
                });
                cp[name] = single ? arr[0] : arr;
            });
            if (Object.keys(cp).length) props.coordinateProperties = cp;
            feats.push({ type: 'Feature', properties: props, geometry: single ? { type: 'LineString', coordinates: lines[0] } : { type: 'MultiLineString', coordinates: lines } });
        });
        (doc.waypoints || []).forEach(function (w) {
            var p = {};
            if (w.name) p.name = w.name;
            if (w.desc) p.desc = w.desc;
            if (ok(w.time)) p.time = iso(w.time);
            if (w.sym) p.sym = w.sym;
            var c = [+f7(w.lon), +f7(w.lat)];
            if (ok(w.ele)) c.push(+f1(w.ele));
            feats.push({ type: 'Feature', properties: p, geometry: { type: 'Point', coordinates: c } });
        });
        (doc.areas || []).forEach(function (a) {
            feats.push({ type: 'Feature', properties: a.name ? { name: a.name } : {}, geometry: { type: 'Polygon', coordinates: a.rings } });
        });
        return JSON.stringify({ type: 'FeatureCollection', features: feats }, null, o.pretty ? 1 : 0);
    }

    // ── TCX ────────────────────────────────────────────────────────────────
    var TCX_SPORT = { running: 'Running', walking: 'Running', hiking: 'Running', cycling: 'Biking', e_biking: 'Biking', mountain: 'Biking', road: 'Biking' };
    function tcx(doc, o) {
        o = o || {};
        var G = root.GpsGeo;
        var out = [prolog(), '<TrainingCenterDatabase xmlns="http://www.garmin.com/xmlschemas/TrainingCenterDatabase/v2" xmlns:ns3="http://www.garmin.com/xmlschemas/ActivityExtension/v2" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.garmin.com/xmlschemas/TrainingCenterDatabase/v2 http://www.garmin.com/xmlschemas/TrainingCenterDatabasev2.xsd">\n'];
        out.push(o.course ? '<Courses>\n' : '<Activities>\n');
        (doc.tracks || []).forEach(function (t) {
            var sr = G.series(t);
            if (!sr.n) return;
            var times = sr.time;
            if (o.course && !times) times = synthTimes(sr, o.speed || 4.2);
            if (!times && !o.course) return; // an activity without time is not an activity; the caller offers «add time» first
            var st = G.stats(sr);
            if (o.course) {
                var nm = (t.name || doc.name || 'Course').slice(0, 15);
                out.push('<Course><Name>' + esc(nm) + '</Name>\n<Lap><TotalTimeSeconds>' + ((times[sr.n - 1] - times[0]) / 1000).toFixed(1) + '</TotalTimeSeconds><DistanceMeters>' + st.distance.toFixed(1) +
                    '</DistanceMeters><BeginPosition><LatitudeDegrees>' + f7(sr.lat[0]) + '</LatitudeDegrees><LongitudeDegrees>' + f7(sr.lon[0]) + '</LongitudeDegrees></BeginPosition><EndPosition><LatitudeDegrees>' + f7(sr.lat[sr.n - 1]) + '</LatitudeDegrees><LongitudeDegrees>' + f7(sr.lon[sr.n - 1]) + '</LongitudeDegrees></EndPosition><Intensity>Active</Intensity></Lap>\n<Track>\n');
                for (var i = 0; i < sr.n; i++) out.push(tcxPt(sr, i, times));
                out.push('</Track>\n');
                (doc.waypoints || []).forEach(function (w) {
                    var near = nearestIdx(sr, w.lat, w.lon);
                    out.push('<CoursePoint><Name>' + esc((w.name || 'Point').slice(0, 10)) + '</Name><Time>' + iso(times[near]) + '</Time><Position><LatitudeDegrees>' + f7(w.lat) + '</LatitudeDegrees><LongitudeDegrees>' + f7(w.lon) + '</LongitudeDegrees></Position><PointType>Generic</PointType></CoursePoint>\n');
                });
                out.push('</Course>\n');
                return;
            }
            var sport = TCX_SPORT[String(t.sport || '').toLowerCase()] || 'Other';
            var start = times[0];
            out.push('<Activity Sport="' + sport + '"><Id>' + iso(start) + '</Id>\n');
            var laps = lapRanges(t, sr, times);
            laps.forEach(function (L) {
                var ls = G.stats(sr, { from: L.from, to: L.to });
                out.push('<Lap StartTime="' + iso(times[L.from]) + '"><TotalTimeSeconds>' + (ls.moving != null ? ls.moving : ls.elapsed || 0).toFixed(1) + '</TotalTimeSeconds><DistanceMeters>' + ls.distance.toFixed(1) + '</DistanceMeters>' +
                    (ls.maxSpeed ? '<MaximumSpeed>' + ls.maxSpeed.toFixed(3) + '</MaximumSpeed>' : '') + '<Calories>' + Math.round(L.calories || 0) + '</Calories>' +
                    (ls.hr ? '<AverageHeartRateBpm><Value>' + Math.max(1, Math.round(ls.hr.avg)) + '</Value></AverageHeartRateBpm><MaximumHeartRateBpm><Value>' + Math.max(1, Math.round(ls.hr.max)) + '</Value></MaximumHeartRateBpm>' : '') +
                    '<Intensity>Active</Intensity><TriggerMethod>Manual</TriggerMethod>\n<Track>\n');
                for (var i = L.from; i <= L.to; i++) {
                    if (i > L.from && isSegStart(sr, i)) out.push('</Track>\n<Track>\n');
                    out.push(tcxPt(sr, i, times));
                }
                out.push('</Track>\n</Lap>\n');
            });
            out.push('<Creator xsi:type="Device_t"><Name>' + esc(doc.device || 'Timbrica') + '</Name><UnitId>0</UnitId><ProductID>0</ProductID><Version><VersionMajor>1</VersionMajor><VersionMinor>0</VersionMinor></Version></Creator>\n</Activity>\n');
        });
        out.push(o.course ? '</Courses>\n' : '</Activities>\n');
        out.push('</TrainingCenterDatabase>\n');
        return out.join('');
    }
    function isSegStart(sr, i) { return sr.segStart.indexOf(i) >= 0; }
    function tcxPt(sr, i, times) {
        var s = '<Trackpoint><Time>' + iso(times[i]) + '</Time><Position><LatitudeDegrees>' + f7(sr.lat[i]) + '</LatitudeDegrees><LongitudeDegrees>' + f7(sr.lon[i]) + '</LongitudeDegrees></Position>';
        if (sr.ele && ok(sr.ele[i])) s += '<AltitudeMeters>' + f1(sr.ele[i]) + '</AltitudeMeters>';
        s += '<DistanceMeters>' + sr.dist[i].toFixed(1) + '</DistanceMeters>';
        var hr = sr.ch.hr && sr.ch.hr[i];
        if (ok(hr) && hr >= 1) s += '<HeartRateBpm><Value>' + Math.min(255, Math.round(hr)) + '</Value></HeartRateBpm>';
        var cad = sr.ch.cad && sr.ch.cad[i];
        if (ok(cad)) s += '<Cadence>' + Math.min(254, Math.round(cad)) + '</Cadence>';
        var pw = sr.ch.power && sr.ch.power[i], sp = sr.ch.speed && sr.ch.speed[i];
        if (ok(pw) || ok(sp)) s += '<Extensions><ns3:TPX>' + (ok(sp) ? '<ns3:Speed>' + sp.toFixed(3) + '</ns3:Speed>' : '') + (ok(pw) ? '<ns3:Watts>' + Math.round(pw) + '</ns3:Watts>' : '') + '</ns3:TPX></Extensions>';
        return s + '</Trackpoint>\n';
    }
    function lapRanges(t, sr, times) {
        var laps = (t.laps || []).filter(function (l) { return ok(l.start); });
        if (laps.length < 2) return [{ from: 0, to: sr.n - 1, calories: laps[0] ? laps[0].calories : null }];
        var out = [];
        for (var k = 0; k < laps.length; k++) {
            var from = firstAtOrAfter(times, laps[k].start);
            var to = k + 1 < laps.length ? firstAtOrAfter(times, laps[k + 1].start) - 1 : sr.n - 1;
            if (from < 0) continue;
            if (to < from) to = from;
            out.push({ from: from, to: Math.min(to, sr.n - 1), calories: laps[k].calories });
        }
        return out.length ? out : [{ from: 0, to: sr.n - 1 }];
    }
    function firstAtOrAfter(times, t) {
        for (var i = 0; i < times.length; i++) if (times[i] >= t) return i;
        return -1;
    }
    function nearestIdx(sr, lat, lon) {
        var best = 0, bd = Infinity;
        for (var i = 0; i < sr.n; i++) {
            var dy = sr.lat[i] - lat, dx = (sr.lon[i] - lon) * Math.cos(lat * Math.PI / 180), d = dx * dx + dy * dy;
            if (d < bd) { bd = d; best = i; }
        }
        return best;
    }
    function synthTimes(sr, speedMs, startMs) {
        var t = new Float64Array(sr.n);
        var base = startMs != null ? startMs : Date.UTC(2020, 0, 1, 8, 0, 0);
        for (var i = 0; i < sr.n; i++) t[i] = base + Math.round(sr.dist[i] / speedMs * 1000);
        return t;
    }

    // ── CSV ────────────────────────────────────────────────────────────────
    function csv(doc, o) {
        o = o || {};
        var G = root.GpsGeo;
        var sep = o.sep || ',';
        var rows = [];
        var cols = ['track', 'segment', 'time_utc', 'latitude', 'longitude', 'elevation_m', 'distance_m', 'speed_kmh', 'heart_rate', 'cadence', 'power_w', 'temperature_c'];
        rows.push(cols.join(sep));
        (doc.tracks || []).forEach(function (t, ti) {
            var sr = G.series(t);
            var sp = G.speed(sr);
            var seg = 0;
            for (var i = 0; i < sr.n; i++) {
                if (i > 0 && isSegStart(sr, i)) seg++;
                var v = [ti + 1, seg + 1, sr.time && ok(sr.time[i]) ? iso(sr.time[i]) : '', f7(sr.lat[i]), f7(sr.lon[i]),
                         sr.ele && ok(sr.ele[i]) ? f1(sr.ele[i]) : '', sr.dist[i].toFixed(1), ok(sp[i]) ? (sp[i] * 3.6).toFixed(2) : '',
                         sr.ch.hr && ok(sr.ch.hr[i]) ? Math.round(sr.ch.hr[i]) : '', sr.ch.cad && ok(sr.ch.cad[i]) ? Math.round(sr.ch.cad[i]) : '',
                         sr.ch.power && ok(sr.ch.power[i]) ? Math.round(sr.ch.power[i]) : '', sr.ch.temp && ok(sr.ch.temp[i]) ? f1(sr.ch.temp[i]) : ''];
                rows.push(v.join(sep));
            }
        });
        return rows.join('\n') + '\n';
    }

    // ── FIT ────────────────────────────────────────────────────────────────
    /* A minimal, valid FIT encoder: one definition per message kind, little
     * endian, invalid markers for missing values, header CRC + file CRC. Checked
     * by decoding the output with Garmin's own SDK in tests. */
    var BT = { enum: [0x00, 1], sint8: [0x01, 1], uint8: [0x02, 1], sint16: [0x83, 2], uint16: [0x84, 2], sint32: [0x85, 4], uint32: [0x86, 4], string: [0x07, 0] };
    var INVALID = { enum: 0xFF, sint8: 0x7F, uint8: 0xFF, sint16: 0x7FFF, uint16: 0xFFFF, sint32: 0x7FFFFFFF, uint32: 0xFFFFFFFF };
    var FIT_EPOCH = Date.UTC(1989, 11, 31, 0, 0, 0);
    var SEMI = 2147483648 / 180;
    var FIT_SPORT = { running: 1, walking: 11, hiking: 17, cycling: 2, e_biking: 21, swimming: 5, cross_country_skiing: 12, alpine_skiing: 13, rowing: 15, paddling: 19, kayaking: 41, driving: 24 };

    function FitW() { this.buf = []; this.local = 0; this.defs = {}; }
    FitW.prototype.def = function (name, g, fields) {
        var lt = this.local++ & 0x0F;
        this.defs[name] = { lt: lt, fields: fields };
        var b = [0x40 | lt, 0, 0, g & 0xFF, (g >> 8) & 0xFF, fields.length];
        fields.forEach(function (f) { b.push(f[0], f[2] || BT[f[1]][1], BT[f[1]][0]); });
        push(this.buf, b);
    };
    FitW.prototype.data = function (name, vals) {
        var d = this.defs[name];
        var b = [d.lt];
        d.fields.forEach(function (f, k) {
            var type = f[1], v = vals[k];
            if (type === 'string') {
                var sz = f[2], bytes = utf8(v || '');
                for (var q = 0; q < sz; q++) b.push(q < bytes.length && q < sz - 1 ? bytes[q] : 0);
                return;
            }
            var size = BT[type][1];
            var iv = (v == null || !isFinite(v)) ? INVALID[type] : Math.round(v);
            if (type === 'sint8' && iv !== INVALID.sint8) iv = Math.max(-127, Math.min(126, iv));
            if (type === 'uint8' && iv !== INVALID.uint8) iv = Math.max(0, Math.min(254, iv));
            if (type === 'uint16' && iv !== INVALID.uint16) iv = Math.max(0, Math.min(65534, iv));
            if (type === 'sint16' && iv !== INVALID.sint16) iv = Math.max(-32767, Math.min(32766, iv));
            for (var s = 0; s < size; s++) b.push((iv >>> (8 * s)) & 0xFF);
        });
        push(this.buf, b);
    };
    function push(dst, src) { for (var i = 0; i < src.length; i++) dst.push(src[i]); }
    function utf8(s) {
        if (typeof TextEncoder !== 'undefined') return Array.prototype.slice.call(new TextEncoder().encode(s));
        return s.split('').map(function (c) { return c.charCodeAt(0) & 0x7F; });
    }
    FitW.prototype.bytes = function () {
        var crc16 = root.GpsFitDecode.crc16;
        var data = this.buf;
        var h = [14, 0x20, 0x08, 0x08, data.length & 0xFF, (data.length >> 8) & 0xFF, (data.length >> 16) & 0xFF, (data.length >>> 24) & 0xFF, 0x2E, 0x46, 0x49, 0x54];
        var hc = 0;
        for (var i = 0; i < 12; i++) hc = crc16(hc, h[i]);
        h.push(hc & 0xFF, (hc >> 8) & 0xFF);
        var out = new Uint8Array(14 + data.length + 2);
        out.set(h, 0);
        out.set(data, 14);
        var c = 0;
        for (i = 0; i < 14 + data.length; i++) c = crc16(c, out[i]);
        out[14 + data.length] = c & 0xFF;
        out[15 + data.length] = (c >> 8) & 0xFF;
        return out;
    };

    function fit(doc, o) {
        o = o || {};
        var G = root.GpsGeo;
        var t = (doc.tracks || [])[o.track || 0];
        if (!t) throw new Error('no-track');
        var sr = G.series(t);
        if (!sr.n) throw new Error('no-points');
        var course = !!o.course;
        var times = sr.time;
        // FIT counts seconds from 1989-12-31 in a uint32: a track stamped 1901 (a
        // device that never got a GPS time — real files carry it) cannot be written
        // as is, and is treated as untimed.
        if (times && !Array.prototype.some.call(times, function (v) { return ok(v) && v > FIT_EPOCH; })) times = null;
        if (!times) {
            if (!course) throw new Error('no-time');
            times = synthTimes(sr, o.speed || 4.2, o.start != null ? o.start : Date.now());
        }
        // fill interior time gaps linearly so every record has a timestamp
        times = Float64Array.from(times);
        fillGaps(times);
        var ts = function (ms) { return Math.round((ms - FIT_EPOCH) / 1000); };
        var sport = FIT_SPORT[String(t.sport || '').toLowerCase()];
        if (sport == null) sport = course ? 2 : 0;
        var st = G.stats(sr);
        var w = new FitW();
        var start = times[0], end = times[sr.n - 1];
        w.def('file_id', 0, [[0, 'enum'], [1, 'uint16'], [2, 'uint16'], [4, 'uint32']]);
        w.data('file_id', [course ? 6 : 4, 255, 0, ts(start)]);
        if (course) {
            w.def('course', 31, [[4, 'enum'], [5, 'string', 16]]);
            w.data('course', [sport, (t.name || doc.name || 'Course').slice(0, 15)]);
        }
        w.def('event', 21, [[253, 'uint32'], [0, 'enum'], [1, 'enum'], [4, 'uint8']]);
        w.data('event', [ts(start), 0, 0, 0]);
        var hasEle = !!sr.ele, ch = sr.ch;
        var rf = [[253, 'uint32'], [0, 'sint32'], [1, 'sint32'], [5, 'uint32']];
        if (hasEle) rf.push([2, 'uint16'], [78, 'uint32']);
        if (ch.hr) rf.push([3, 'uint8']);
        if (ch.cad) rf.push([4, 'uint8']);
        if (ch.power) rf.push([7, 'uint16']);
        if (ch.temp) rf.push([13, 'sint8']);
        if (ch.speed) rf.push([6, 'uint16']);
        w.def('record', 20, rf);
        for (var i = 0; i < sr.n; i++) {
            var e = hasEle ? sr.ele[i] : NaN;
            var row = [ts(times[i]), sr.lat[i] * SEMI, sr.lon[i] * SEMI, sr.dist[i] * 100];
            if (hasEle) row.push(ok(e) ? (e + 500) * 5 : null, ok(e) ? (e + 500) * 5 : null);
            if (ch.hr) row.push(ch.hr[i]);
            if (ch.cad) row.push(ch.cad[i]);
            if (ch.power) row.push(ch.power[i]);
            if (ch.temp) row.push(ch.temp[i]);
            if (ch.speed) row.push(ok(ch.speed[i]) ? ch.speed[i] * 1000 : null);
            w.data('record', row);
        }
        w.data('event', [ts(end), 0, 4, 0]);
        var elapsed = (end - start) / 1000;
        var timer = course ? elapsed : (st.moving != null ? st.moving : elapsed);
        var asc = st.climb && st.climb.gain != null ? st.climb.gain : null;
        var desc = st.climb && st.climb.loss != null ? st.climb.loss : null;
        w.def('lap', 19, [[254, 'uint16'], [253, 'uint32'], [0, 'enum'], [1, 'enum'], [2, 'uint32'], [3, 'sint32'], [4, 'sint32'], [5, 'sint32'], [6, 'sint32'],
                          [7, 'uint32'], [8, 'uint32'], [9, 'uint32'], [21, 'uint16'], [22, 'uint16'], [25, 'enum']]);
        w.data('lap', [0, ts(end), 9, 1, ts(start), sr.lat[0] * SEMI, sr.lon[0] * SEMI, sr.lat[sr.n - 1] * SEMI, sr.lon[sr.n - 1] * SEMI,
                       elapsed * 1000, timer * 1000, st.distance * 100, asc, desc, sport]);
        if (course && (doc.waypoints || []).length) {
            w.def('course_point', 32, [[254, 'uint16'], [1, 'uint32'], [2, 'sint32'], [3, 'sint32'], [4, 'uint32'], [5, 'enum'], [6, 'string', 16]]);
            var wps = doc.waypoints.map(function (wp) { var k = nearestIdx(sr, wp.lat, wp.lon); return { wp: wp, k: k }; })
                .sort(function (a, b) { return a.k - b.k; });
            wps.forEach(function (x, n) {
                w.data('course_point', [n, ts(times[x.k]), x.wp.lat * SEMI, x.wp.lon * SEMI, sr.dist[x.k] * 100, 0, (x.wp.name || '').slice(0, 15)]);
            });
        }
        if (!course) {
            w.def('session', 18, [[254, 'uint16'], [253, 'uint32'], [0, 'enum'], [1, 'enum'], [2, 'uint32'], [3, 'sint32'], [4, 'sint32'], [5, 'enum'], [6, 'enum'],
                                  [7, 'uint32'], [8, 'uint32'], [9, 'uint32'], [22, 'uint16'], [23, 'uint16'], [25, 'uint16'], [26, 'uint16'], [16, 'uint8'], [17, 'uint8']]);
            w.data('session', [0, ts(end), 8, 1, ts(start), sr.lat[0] * SEMI, sr.lon[0] * SEMI, sport, 0, elapsed * 1000, timer * 1000, st.distance * 100, asc, desc, 0, 1,
                               st.hr ? st.hr.avg : null, st.hr ? st.hr.max : null]);
            w.def('activity', 34, [[253, 'uint32'], [0, 'uint32'], [1, 'uint16'], [2, 'enum'], [3, 'enum'], [4, 'enum']]);
            w.data('activity', [ts(end), timer * 1000, 1, 0, 26, 1]);
        }
        return w.bytes();
    }
    function fillGaps(t) {
        var n = t.length, i = 0;
        while (i < n) {
            if (!isNaN(t[i])) { i++; continue; }
            var a = i - 1, b = i;
            while (b < n && isNaN(t[b])) b++;
            var ta = a >= 0 ? t[a] : (b < n ? t[b] - 1000 * (b - a) : 0);
            var tb = b < n ? t[b] : ta + 1000 * (b - a);
            for (var k = i; k < b; k++) t[k] = ta + (tb - ta) * (k - a) / (b - a);
            i = b;
        }
    }

    root.GpsWrite = { gpx: gpx, kml: kml, geojson: geojson, tcx: tcx, csv: csv, fit: fit, _synthTimes: synthTimes };
})();
